export default __webpack_public_path__ + "static/media/stat-lightning.5d2647bf.svg";